(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ym-inline-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const init=(root)=>root.querySelectorAll('[data-ym-flow]').forEach((offer)=>{
    if(offer.dataset.initialized)return;
    offer.dataset.initialized='true';
    offer.querySelector('[data-flow-close]').addEventListener('click',()=>{offer.hidden=true;});
    offer.querySelector('[data-flow-copy]').addEventListener('click',async()=>{
      const status=offer.querySelector('[data-flow-status]');
      try{
        await navigator.clipboard.writeText(offer.querySelector('[data-flow-code]').textContent.trim());
        status.textContent=status.dataset.success;
      }catch{status.textContent=status.dataset.failure;}
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
